// Plan comptable PME suisse – référence officielle SKV/swisco
// Utilisé dans toute l'application MyCount
// Méthode : postes ouverts (créanciers/débiteurs systématiques)

export const PLAN_COMPTABLE = {
  // ─── CLASSE 1 : ACTIFS ─────────────────────────────────────────────
  '1000': 'Caisse',
  '1020': 'Banque (avoir)',
  '1060': 'Titres',
  '1069': 'Ajustement de la valeur des titres',
  '1100': 'Créances provenant de livraisons et de prestations (Débiteurs)',
  '1109': 'Ducroire',
  '1110': 'Créances envers sociétés du groupe',
  '1140': 'Avances et prêts',
  '1149': 'Ajustement de la valeur des avances et des prêts',
  '1170': 'Impôt préalable: TVA s/matériel, marchandises, prestations et énergie',
  '1171': 'Impôt préalable: TVA s/investissements et autres charges',
  '1176': 'Impôt anticipé',
  '1180': 'Créances envers les assurances sociales et institutions de prévoyance',
  '1189': 'Impôt à la source',
  '1190': 'Autres créances à court terme',
  '1200': 'Marchandises commerciales',
  '1210': 'Matières premières',
  '1220': 'Matières auxiliaires',
  '1230': 'Matières consommables',
  '1250': 'Marchandises en consignation',
  '1260': 'Stocks de produits finis',
  '1280': 'Travaux en cours',
  '1300': 'Charges payées d\'avance',
  '1301': 'Produits à recevoir',
  '1400': 'Titres à long terme',
  '1409': 'Ajustement de la valeur des titres à long terme',
  '1440': 'Prêts',
  '1441': 'Hypothèques',
  '1449': 'Ajustement de la valeur des créances à long terme',
  '1480': 'Participations',
  '1489': 'Ajustement de la valeur des participations',
  '1500': 'Machines et appareils',
  '1509': 'Ajustement de la valeur des machines et appareils',
  '1510': 'Mobilier et installations',
  '1519': 'Ajustement de la valeur du mobilier et des installations',
  '1520': 'Machines de bureau, informatique, systèmes de communication',
  '1529': 'Ajustement de la valeur des machines de bureau, inf. et syst. comm.',
  '1530': 'Véhicules',
  '1539': 'Ajustement de la valeur des véhicules',
  '1540': 'Outillages et appareils',
  '1549': 'Ajustement de la valeur des outillages et appareils',
  '1600': 'Immeubles d\'exploitation',
  '1609': 'Ajustement de la valeur des immeubles d\'exploitation',
  '1700': 'Brevets, know-how, licences, droits, développement',
  '1709': 'Ajustement de la valeur des brevets, know-how, licences, droits, dév.',
  '1770': 'Goodwill',
  '1779': 'Ajustement de la valeur des goodwill',
  '1850': 'Capital actions, capital social non versés',

  // ─── CLASSE 2 : PASSIFS ────────────────────────────────────────────
  '2000': 'Dettes résultant d\'achats et de prestations de services (Créanciers)',
  '2030': 'Acomptes de clients',
  '2050': 'Dettes envers des sociétés du groupe',
  '2100': 'Dettes à court terme rémunérées (banques)',
  '2120': 'Engagements de financement par leasing',
  '2140': 'Autres dettes à court terme rémunérées',
  '2160': 'Salaires à payer',
  '2200': 'TVA due',
  '2201': 'Décompte TVA',
  '2206': 'Impôt anticipé dû',
  '2208': 'Impôts directs à payer',
  '2210': 'Autres dettes à court terme',
  '2261': 'Dividendes à payer',
  '2270': 'Charges sociales à payer',
  '2271': 'Impôt à la source à payer',
  '2300': 'Passifs de régularisation (charges à payer / produits reçus d\'avance)',
  '2330': 'Provisions à court terme',
  '2400': 'Dettes à long terme rémunérées (emprunts bancaires)',
  '2420': 'Emprunts obligataires',
  '2450': 'Dettes hypothécaires',
  '2500': 'Provisions à long terme et provisions légales',
  '2600': 'Dettes à long terme non rémunérées',
  '2800': 'Capital-actions / capital social',
  '2810': 'Capital-participation',
  '2850': 'Réserves légales issues du capital',
  '2860': 'Actions propres (poste négatif)',
  '2900': 'Réserves légales issues du bénéfice',
  '2950': 'Réserves libres / facultatives',
  '2960': 'Bénéfice / perte reporté',
  '2970': 'Bénéfice / perte de l\'exercice',

  // ─── CLASSE 3 : CHIFFRE D'AFFAIRES ────────────────────────────────
  '3000': 'Ventes de produits fabriqués',
  '3200': 'Ventes de marchandises',
  '3400': 'Ventes de prestations',
  '3600': 'Autres ventes et prestations de services',
  '3700': 'Prestations propres',
  '3710': 'Consommations propres',
  '3800': 'Déductions sur ventes',
  '3805': 'Pertes sur clients, variation du ducroire',
  '3900': 'Variation des stocks de produits semi-finis',
  '3901': 'Variation des stocks de produits finis',
  '3940': 'Variation de la valeur des prestations non facturées',

  // ─── CLASSE 4 : CHARGES DE MATÉRIEL, MARCHANDISES, PRESTATIONS ───
  '4000': 'Charges de matériel de l\'atelier',
  '4200': 'Achats de marchandises destinées à la revente',
  '4400': 'Prestations / travaux de tiers',
  '4500': 'Charges d\'énergie pour l\'exploitation',
  '4900': 'Déductions sur les charges',

  // ─── CLASSE 5 : CHARGES DE PERSONNEL ─────────────────────────────
  '5000': 'Salaires',
  '5700': 'Charges sociales',
  '5800': 'Autres charges du personnel',
  '5900': 'Charges de personnels temporaires',

  // ─── CLASSE 6 : AUTRES CHARGES D'EXPLOITATION, AMORTISSEMENTS, RÉSULTAT FINANCIER
  '6000': 'Charges de locaux',
  '6100': 'Entretien, réparations et remplacement',
  '6105': 'Leasing immobilisations corporelles meubles',
  '6200': 'Charges de véhicules et de transport',
  '6260': 'Leasing et location de véhicules',
  '6300': 'Assurances-choses, droits, taxes, autorisations',
  '6400': 'Charges d\'énergie et évacuation des déchets',
  '6500': 'Charges d\'administration',
  '6570': 'Charges et leasing d\'informatique',
  '6600': 'Publicité',
  '6700': 'Autres charges d\'exploitation',
  '6800': 'Amortissement et ajustement de valeur des immobilisations corporelles',
  '6900': 'Charges financières',
  '6950': 'Produits financiers',

  // ─── CLASSE 7 : RÉSULTAT DES ACTIVITÉS ANNEXES D'EXPLOITATION ────
  '7000': 'Produits accessoires',
  '7010': 'Charges accessoires',
  '7500': 'Produits des immeubles d\'exploitation',
  '7510': 'Charges des immeubles d\'exploitation',

  // ─── CLASSE 8 : RÉSULTATS EXTRAORDINAIRES ET HORS EXPLOITATION ───
  '8000': 'Charges hors exploitation',
  '8100': 'Produits hors exploitation',
  '8500': 'Charges extraordinaires, exceptionnelles ou hors période',
  '8510': 'Produits extraordinaires, exceptionnels ou hors période',
  '8900': 'Impôts directs',

  // ─── CLASSE 9 : CLÔTURE ──────────────────────────────────────────
  '9200': 'Bénéfice / perte de l\'exercice',
};

// Comptes les plus utilisés dans les exercices (pour référence rapide)
export const COMPTES_CLES = [
  { num: '1000', label: 'Caisse' },
  { num: '1020', label: 'Banque' },
  { num: '1100', label: 'Débiteurs' },
  { num: '1109', label: 'Ducroire' },
  { num: '1170', label: 'Impôt préalable TVA' },
  { num: '1200', label: 'Marchandises commerciales' },
  { num: '1280', label: 'Travaux en cours' },
  { num: '1300', label: 'Charges payées d\'avance' },
  { num: '1301', label: 'Produits à recevoir' },
  { num: '1500', label: 'Machines et appareils' },
  { num: '1510', label: 'Mobilier et installations' },
  { num: '1519', label: 'Ajustement valeur mobilier' },
  { num: '1520', label: 'Machines de bureau, informatique' },
  { num: '1530', label: 'Véhicules' },
  { num: '1539', label: 'Ajustement valeur véhicules' },
  { num: '1600', label: 'Immeubles d\'exploitation' },
  { num: '1850', label: 'Capital non versé' },
  { num: '2000', label: 'Créanciers' },
  { num: '2100', label: 'Dettes bancaires CT' },
  { num: '2160', label: 'Salaires à payer' },
  { num: '2200', label: 'TVA due' },
  { num: '2201', label: 'Décompte TVA' },
  { num: '2206', label: 'Impôt anticipé dû' },
  { num: '2208', label: 'Impôts directs à payer' },
  { num: '2270', label: 'Charges sociales à payer' },
  { num: '2271', label: 'Impôt à la source à payer' },
  { num: '2300', label: 'Passifs de régularisation' },
  { num: '2330', label: 'Provisions à court terme' },
  { num: '2450', label: 'Dettes hypothécaires' },
  { num: '2500', label: 'Provisions à long terme' },
  { num: '2800', label: 'Capital-actions / capital social' },
  { num: '2850', label: 'Réserves légales issues du capital' },
  { num: '2900', label: 'Réserves légales issues du bénéfice' },
  { num: '2950', label: 'Réserves libres' },
  { num: '2960', label: 'Bénéfice / perte reporté' },
  { num: '2970', label: 'Bénéfice / perte de l\'exercice' },
  { num: '3000', label: 'Ventes de produits fabriqués' },
  { num: '3200', label: 'Ventes de marchandises' },
  { num: '3400', label: 'Ventes de prestations' },
  { num: '3800', label: 'Déductions sur ventes' },
  { num: '3805', label: 'Pertes sur clients / ducroire' },
  { num: '3900', label: 'Variation des stocks' },
  { num: '4000', label: 'Charges de matériel' },
  { num: '4200', label: 'Achats de marchandises' },
  { num: '5000', label: 'Salaires' },
  { num: '5700', label: 'Charges sociales' },
  { num: '6000', label: 'Charges de locaux' },
  { num: '6100', label: 'Entretien, réparations' },
  { num: '6200', label: 'Charges de véhicules' },
  { num: '6300', label: 'Assurances, taxes' },
  { num: '6500', label: 'Charges d\'administration' },
  { num: '6600', label: 'Publicité' },
  { num: '6700', label: 'Autres charges d\'exploitation' },
  { num: '6800', label: 'Amortissements' },
  { num: '6900', label: 'Charges financières' },
  { num: '6950', label: 'Produits financiers' },
  { num: '7000', label: 'Produits accessoires' },
  { num: '7500', label: 'Produits immeubles' },
  { num: '8000', label: 'Charges hors exploitation' },
  { num: '8100', label: 'Produits hors exploitation' },
  { num: '8500', label: 'Charges extraordinaires' },
  { num: '8510', label: 'Produits extraordinaires' },
  { num: '8900', label: 'Impôts directs' },
];

export function getAccountLabel(num) {
  return PLAN_COMPTABLE[num] || num;
}
